// import { MDBModalRef } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { Component, Inject, OnInit } from '@angular/core';
import { ValidatorUtils } from 'src/app/utils/validator.utils';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-popup-shopping',
  templateUrl: './popup-shopping.component.html',
  styleUrls: ['./popup-shopping.component.scss'],
})
export class PopupShoppingComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<PopupShoppingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {} // public modalRef: MDBModalRef,

  validator = new ValidatorUtils();

  loading = false;
  action: Subject<any> = new Subject();

  auction: any = null;
  page = 1;
  qtd: any = 1;
  qtd_choice: any = 1;

  ngOnInit(): void {
    this.auction = this.data.auction;
    this.qtd = this.data.auction.qtd;
    this.data.auction.bids.forEach((item: any) => {
      if (item.status === 'ACEITO') {
        this.qtd -= item.qtd;
      }
    });
  }

  generateArray(qtd: number): number[] {
    return Array.from({ length: qtd }, (_, i) => i + 1);
  }

  nextPage() {
    this.page++;
  }

  chance(chance: 'yes' | 'no' | 'login', results?: any): void {
    this.dialogRef.close({ action: chance, results });
  }

  closePopup() {
    this.action.next('no');
    // this.modalRef.hide();
  }

  convertMoney(money: any) {
    return this.validator.convertMoney(money);
  }

  finish() {
    this.dialogRef.close({ action: 'yes', results: this.qtd_choice });
  }

  reload() {
    // #reload page
    window.location.reload();
  }
}
